import { render, staticRenderFns } from "./productDemonstration.vue?vue&type=template&id=538f053c&scoped=true"
import script from "./productDemonstration.vue?vue&type=script&lang=js"
export * from "./productDemonstration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538f053c",
  null
  
)

export default component.exports